<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <div class="row">
      <div class="col text-right align-self-end">
        <button
          @click="() => $router.push({ name: 'DetailServiceMaster' })"
          class="btn btn-outline-primary"
        >
          Create
        </button>
      </div>
    </div>
    <div class="row align-items-center">
      <div class="col-3">
        <BrandDropdown
          v-model="brandSelected"
          @setBrand="setBrand"
          :styleObject="brandDropDownStyle"
        ></BrandDropdown>
      </div>
      <div class="col-3">
        <label for="searchBox">Search</label>
        <input
          id="searchBox"
          type="text"
          v-model="keyword"
          class="form-control"
          style="margin: 0.7rem 0"
        />
      </div>
      <div class="col-3">
        <label for="statusDropdown">Status</label>
        <multiselect
          id="statusDropdown"
          v-model="statusSelected"
          :options="statusOptions"
          label="text"
          track-by="text"
          style="margin: 0.6rem 0"
        >
        </multiselect>
      </div>
      <div class="col-3 d-flex" style="margin-top: auto">
        <div class="p-2 align-self-center">
          <button
            class="btn btn-outline-secondary"
            style="width: 100%; max-width: 131px"
            @click="resetFilter"
          >
            Reset
          </button>
        </div>
        <div class="p-2 align-self-center">
          <button
            class="btn btn-outline-primary"
            style="width: 100%; max-width: 131px"
            @click="searchServiceMaster"
          >
            OK
          </button>
        </div>
      </div>
    </div>
    <div class="mt-3">
      <div class="row">
        <div class="d-flex align-items-center justify-content-start col">
          <span class="mr-2">Show</span>
          <b-form-select
            class="form-control w-auto"
            v-model="perPage"
            :options="pageOptions"
            @change="onChangeEntries"
          ></b-form-select>
          <span class="ml-2">entries</span>
        </div>
      </div>
      <b-table
        class="table table-responsive table-bordered mt-5"
        hover
        responsive
        :fields="fields"
        :items="serviceMasterList"
        :per-page="perPage"
        @sort-changed="sortCompare"
      >
        <template #table-caption v-if="serviceMasterList.length === 0">
          <h5 class="text-center pt-10">There is no service master data</h5>
        </template>
        <template #cell(action)="data">
          <div class="d-flex justify-content-evenly">
            <router-link
              :to="{
                name: 'DetailServiceMaster',
                query: { id: data.item.id },
              }"
              class="btn btn-outline-primary"
              >Detail</router-link
            >
          </div>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
        class="my-0"
        aria-controls="my-table"
        @input="changePage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import BrandDropdown from "components/Brand/BrandDropdown";
import DefaultListViewData from "@/views/defaultListViewData";
import ServiceMasterService from "services/api/serviceMaster.service";
import fields from "./listServiceMasterFields.json";

export default {
  components: {
    BrandDropdown,
  },

  data() {
    return {
      ...DefaultListViewData,
      statusOptions: [{ text: "ACTIVE" }, { text: "INACTIVE" }],
      statusSelected: null,
      keyword: null,
      isSubmit: false,
      message: null,
      serviceMasterList: [],
      fields,
      brandDropDownStyle: {
        margin: "0.6rem 0",
      },
    };
  },

  async mounted() {
    this.isLoading = true;
    await this.getServiceMasters();
  },

  methods: {
    async getServiceMasters() {
      const param = this.getParams();

      await ServiceMasterService.getListServiceMaster(param)
        .then((res) => {
          const data = res.data;
          this.totalItems = data.totalItems;
          this.serviceMasterList = data.services.map((r) => {
            return {
              ...r,
              status: this.leadWithUpperCase(r.status),
              dateCreated: this.setFormatDate(r.dateCreated),
              lastUpdated: this.setFormatDate(r.lastUpdated),
            };
          });
          this.isLoading = false;
        })
        .catch((err) => {
          console.log("Error: ", err);
          this.isLoading = false;
        });
    },
    getParams() {
      return {
        brandCode: this.brandSelected ? this.brandSelected.id : null,
        status: this.statusSelected ? this.statusSelected.text : null,
        keyword: this.keyword,
        currentPage: this.currentPage,
        limit: this.perPage,
        sortColumn: this.sort.key || "id",
        sortType: this.sort.type || "desc",
      };
    },
    leadWithUpperCase(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    searchServiceMaster() {
      this.isLoading = true;
      this.getServiceMasters();
    },
    resetFilter() {
      this.brandSelected = null;
      this.statusSelected = null;
      this.keyword = null;
      this.getServiceMasters();
    },
    changePage() {
      this.getServiceMasters();
    },
    onChangeEntries() {
      this.getServiceMasters();
    },
    sortCompare(e) {
      let sortBy = e.sortBy;
      this.sort = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getServiceMasters();
    },
    setBrand(brand) {
      this.brandSelected = brand || "";
    },
    setFormatDate(value) {
      return moment(value).format("YYYY-MM-DD HH:mm:ss");
    },
  },
};
</script>

<style lang="scss" scoped>
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
</style>
